import { Outlet } from 'react-router-dom';
import { PortalNavigation } from '@/components/portal/PortalNavigation';
import { PortalActiveClinicProvider } from '@/lib/portalActiveClinic';

/**
 * Layout wrapper for the patient portal.
 * Provides consistent navigation and structure for all portal pages.
 */
export function PortalLayout() {
  return (
    <PortalActiveClinicProvider>
      <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
        <PortalNavigation />
        <main className="mx-auto max-w-7xl px-4 py-8 sm:px-6 lg:px-8">
          <Outlet />
        </main>
      </div>
    </PortalActiveClinicProvider>
  );
}
